const SESSION_EXPIRY_KEY = 'session_expires_at';

let fallbackExpiryMs = null;
let storageWritable = true;

export const setSessionExpiry = expiresInSeconds => {
  if (!expiresInSeconds) return;

  fallbackExpiryMs = Date.now() + expiresInSeconds * 1000;
  try {
    localStorage.setItem(SESSION_EXPIRY_KEY, String(fallbackExpiryMs));
    storageWritable = true;
  } catch {
    storageWritable = false;
  }
};

export const getSessionExpiryMs = () => {
  if (!storageWritable) return fallbackExpiryMs;

  try {
    return Number(localStorage.getItem(SESSION_EXPIRY_KEY)) || null;
  } catch {
    return fallbackExpiryMs;
  }
};

export const clearSessionExpiry = () => {
  fallbackExpiryMs = null;
  try {
    localStorage.removeItem(SESSION_EXPIRY_KEY);
  } catch {}
};

const ADMIN_ROUTE_KEY = 'admin-route';

export const setAdminRoute = route => {
  try {
    sessionStorage.setItem(ADMIN_ROUTE_KEY, route);
  } catch {}
};

export const getAdminRoute = () => {
  try {
    return sessionStorage.getItem(ADMIN_ROUTE_KEY) || '/admin/users';
  } catch {
    return '/admin/users';
  }
};
